import React, {useState} from 'react';
import testSocialCycleHistoryObject from "./testSocialCycleHistoryObject";
import Widget from "../../prefabricated/Widget";
import {Button} from "@material-ui/core";
import {
    bbDangerousStringToDate,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString
} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {
    Legend,
    Bar,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip as ReChartsTooltip,
    ComposedChart,
    ResponsiveContainer, Area, ReferenceLine
} from 'recharts';
import BRSocialTestsCycleHistoryDialog from "./BRSocialTestsCycleHistoryDialog";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";

const testData = testSocialCycleHistoryObject;


// const CustomLegend=({payload})=>{
//     const payloadToUse = payload && payload[0] && payload[0].payload;
//
//     console.log(payload);
//     return(
//         <div className={"mt-1 pt-1 text-center row"}>
//             <div className={"col-3"}>
//
//             </div>
//             <div className={"col-6"}>
//                 <div className={"row"}>
//                     {payload.map((entry, index)=>(
//                         <p key={`${index}-item`}
//                             className={"col-sm-3 m-0 p-0"}
//                             style={{color: `${entry.color}`, }}>
//                             {entry.value}
//                         </p>
//                     ))}
//                 </div>
//             </div>
//             <div className={"col-3"}>
//
//             </div>
//
//         </div>
//     )
// }


const CustomTooltip=({ payload, label, active, })=> {

    if(active && payload){
        // console.log("payload is",payload);
        return (
            <Widget styleName={`p-1 px-2`}>
                <Row className={"m-1 p-1 text-center"}>
                    <Col>
                        <h3>Date: <em> {bbFormattedDateString(label, "shortFullMonth")} </em></h3>
                    </Col>
                </Row>


                <Row>
                    <Col sm={4} className={"text-center m-0 p-0"}>
                        <h4 className={"d-inline d-print-inline text-bb-risk-medium text-center"}>
                            {payload[0].payload.Opened ? payload[0].payload.Opened : 0}
                        </h4>
                        <p className={" text-bb-risk-medium m-0 p-0"}>
                            &nbsp;Opens
                        </p>
                    </Col>
                    <Col sm={4} className={"text-center m-0 p-0"}>
                        <h4 className={"d-inline d-print-inline text-bb-risk-high text-center"}>
                            {payload[0].payload.Executed ? payload[0].payload.Executed : 0}
                        </h4>
                        <p className={" text-bb-risk-high m-0 p-0"}>
                            &nbsp;Executions
                        </p>
                    </Col>
                    <Col sm={4} className={"text-center m-0 p-0"}>
                        <h4 className={"d-inline d-print-inline text-bb-risk-highest text-center"}>
                            {payload[0].payload.Breached ? payload[0].payload.Breached : 0}
                        </h4>
                        <p className={" text-bb-risk-highest m-0 p-0"}>
                            &nbsp;Breaches
                        </p>
                    </Col>
                </Row>
                <hr/>

                <Row className={"mr-1 ml-1 pr-1 pl-1 mb-0 pb-0 text-center"}>
                    <Col className={"mb-0 pb-0"}>
                        <h1 className={"mb-0 pb-0"}>Spearphishing Emails Sent: {payload[0].payload.Tests}</h1>
                    </Col>
                </Row>


                <Row className={"mr-1 ml-1 pr-1 pl-1 mt-0 pt-0 text-center"}>
                    <Col>
                        <h1>Resulting Events: {payload[0].payload["Total Events"]}</h1>
                    </Col>
                </Row>

                {/*<Row className={"text-center"}>*/}
                {/*    <BRSocialTestsCycleHistoryDialog cycleId={payload[0].payload.id}/>*/}
                {/*</Row>*/}

            </Widget>

        );
    }

    return null;

}

const bbTickFormatter = (input) => {
    return bbFormattedDateString(input, 'micro');
}


const BRSocialCycleHistoryChart = ({cycleId=null, cycleChangeFunction = null}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError} = useSelector(({breachrisk}) => breachrisk);
    // const customer = customers ? customers[customerInView] : null;

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const lastCycleDateTime = myEntity && myEntity.settings && myEntity.settings.last_cycle_datetime;

    let historyData = myEntity
        && myEntity.history
            ? myEntity.history : null;
    // let historyData = testData;

    const historyDataWithSocialTests = historyData
        && historyData.filter((cycle)=> cycle && cycle.social );

    const socialCycleHistory = historyDataWithSocialTests && historyDataWithSocialTests.map((cycle)=>{


        return{
            id: cycle.cycle,
            cycleDate: cycle.cycle_date,
            Tests: cycle.social ? cycle.social.tests : null,
            Opened: cycle.social ? cycle.social.opens : null,
            Executed: cycle.social ? cycle.social.executions : null,
            Breached: cycle.social ? cycle.social.success : null,
            "Total Events": cycle.social && (cycle.social.opens + cycle.social.executions + cycle.social.success),
        }
    })

    const sortedHistoryData = socialCycleHistory
        ? socialCycleHistory.sort((a,b) => (bbDangerousStringToDate(a.cycleDate) > bbDangerousStringToDate(b.cycleDate) ? 1 : -1)) : null;

    const totalNumDataPoints = sortedHistoryData ? sortedHistoryData.length : null;
    const numDataPointsToShow = 20;
    if(totalNumDataPoints && totalNumDataPoints > numDataPointsToShow){
        const numPointsToRemove = totalNumDataPoints - numDataPointsToShow;
        const removedHistoryData = sortedHistoryData.splice(0, numPointsToRemove);
    }

    const indexOfCycleToView = cycleId && sortedHistoryData ? sortedHistoryData.findIndex((cycle)=> cycle.id === cycleId) : null;
    const cycleDateForRefLine = indexOfCycleToView
        && sortedHistoryData
        && sortedHistoryData[indexOfCycleToView]
        && sortedHistoryData[indexOfCycleToView].cycleDate;

    const defaultLastCycleDateTime = sortedHistoryData && sortedHistoryData.length && !cycleId ?
        sortedHistoryData[sortedHistoryData.length - 1].cycleDate
        : null;

    function demoOnClick(e) {
        alert(e);
    }

    const clickChartAndShowCycleDetails = (data, secondSlot) => {
        console.log("Chart pressed. Data is ", data, secondSlot, "cycleChangeFunction", cycleChangeFunction);
            if (cycleChangeFunction && data && data.payload && data.payload.id) {
                cycleChangeFunction(data.payload.id);
            }
    }

    // console.log("reference line", "cycleDateForrefline", cycleId, cycleDateForRefLine, "defaultlastcycledatetime", defaultLastCycleDateTime);

    return (
        <Widget styleName={`p-2 animated fadeIn animation-duration-5 dataTile`}>
            <Row id={"tourSocialResponseChart"}>
                <Col lg={12}>
                    {/*<h1 className={"text-center"}>Spearphishing History*/}
                        <Tooltip title={"Use the chart to view overall details and select a date below the chart to view more details about individual repsonses."}>
                            <InfoSharpIcon className={`text-muted close align-self-center`}/>
                        </Tooltip>
                    {/*</h1>*/}

                </Col>

            </Row>

            <Row>
                <ResponsiveContainer height={400} minWidth={400}>
                    <ComposedChart width={800} height={400} data={sortedHistoryData}
                                   barGap={0}
                                   margin={{top: 1, right: 10, left: 2, bottom: 5}}>
                        <defs>
                            <linearGradient id="purple" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#69A5FF" stopOpacity={0.8}/>
                                <stop offset="95%" stopColor="#69A5FF" stopOpacity={0}/>
                            </linearGradient>
                        </defs>
                        <Area type="monotone" name="Emails Sent" dataKey="Tests" activeDot={{ r: 8, onClick: clickChartAndShowCycleDetails }} strokeWidth={4} stroke="#8884d8" fillOpacity={1} fill="url(#purple)" onClick={clickChartAndShowCycleDetails}/>
                        {/*<Line type="monotone" name="Emails Sent" dataKey="Tests" activeDot={{ r: 8, onClick: clickChartAndShowCycleDetails }} strokeWidth={4} fill="#00863B" onClick={clickChartAndShowCycleDetails}/>*/}
                        <Bar dataKey="Opened" fill="#F2E205" stackId="stack1" barSize={30} onClick={clickChartAndShowCycleDetails}/>
                        <Bar dataKey="Executed" fill="#F28705" stackId="stack1" barSize={25} onClick={clickChartAndShowCycleDetails}/>
                        <Bar dataKey="Breached" fill="#D93D04" stackId="stack1" barSize={20} onClick={clickChartAndShowCycleDetails}/>
                        {cycleId && cycleDateForRefLine
                            ? <ReferenceLine x={`${cycleDateForRefLine}`} stroke="red"/>
                            : <ReferenceLine x={`${defaultLastCycleDateTime}`} stroke="red" />
                        }
                        {/*<Area dataKey="totalEvents" fillOpacity={1} fill="url(#colorUv)"*/}
                        {/*      strokeWidth={0} />*/}
                        <XAxis dataKey="cycleDate" tickFormatter={bbTickFormatter}/>
                        <YAxis/>
                        {/*<ReChartsTooltip/>*/}
                        <ReChartsTooltip content={<CustomTooltip/>}/>
                        <Legend />
                    </ComposedChart>
                </ResponsiveContainer>
            </Row>
        </Widget>
    )
}

export default BRSocialCycleHistoryChart;